module.exports = __webpack_public_path__ + "img/level2addon_mining_tool_shadow-2.ca44bf25.png";